import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { Label } from '@/types/workflow-types';
import { getOrgLabels } from '@/services/workflow/get-org-labels';
import { useOrgStore } from '@/stores/org-store';

export const ORG_LABELS_QUERY_KEY = 'org-labels';

export const useGetOrgLabels = (
  options?: Partial<UseQueryOptions<Label[], Error>>,
) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<Label[], Error>({
    queryKey: [ORG_LABELS_QUERY_KEY, orgId],
    queryFn: async () => {
      if (!orgId) throw new Error('No org ID');
      const response = await getOrgLabels(orgId);
      return response.data?.labels ?? [];
    },
    enabled: !!orgId,
    ...options,
  });
};
